import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useRedirection } from 'src/hooks/useRedirection'
import { RedirectionType } from 'src/redux/redirections/redux'

import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { BannerTitleTextButtonProps } from '../../components/BannerTitleTextButton'
import { BannerTitleTextButtonVariant } from '../../components/BannerTitleTextButton/styled'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'

export function useBannerTitleTextButtonAlertProps({
  t,
  isLogin,
  openAlertModal,
}: {
  t: any
  isLogin: boolean
  openAlertModal: () => void
}): BannerTitleTextButtonProps | undefined {
  const { asPath } = useRouter()
  const { hasRedirected, redirectType, setRedirection, resetRedirection } =
    useRedirection()

  useEffect(() => {
    if (hasRedirected && redirectType === RedirectionType.Alert) {
      openAlertModal()
      resetRedirection()
    }
  }, [hasRedirected, redirectType, openAlertModal, resetRedirection])

  return {
    title: t('banner_title_text_button_alert_title'),
    text: t('banner_title_text_button_alert_text'),
    id: 'alert',
    button: {
      ...(isLogin && {
        onClick: openAlertModal,
      }),
      ...(!isLogin && {
        onClick: () => {
          setRedirection(RedirectionType.Alert, asPath)
          Router.push(Router.getRouteUrl(routes.loginOrRegister))
        },
      }),
      text: t('banner_title_text_button_alert_button_text'),
      variant: ActionButtonVariant.quaternary,
    },
    variant: BannerTitleTextButtonVariant.primary,
  }
}
